

<app-alert></app-alert>

<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Issues List</strong>
    </span>
    <span style="float:right">
      <!-- <a routerLink="/ncd-issue/add"> -->
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" (click)="add()" type="button">
          <i class="fa fa-plus"></i>&nbsp;Create New Issue</button>
      <!-- </a> -->
    </span>
  </div>

  <section class="card search-box">
    <div class="card-header"(click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
      <span class="pull-right">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <form (document:click)="a.close();b.close();">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-2">
                <label class="form-control-label">Secured/Unsecured :</label>
                <div class="input-group">
                  <select class="form-control" id="securityKey" style="padding:6px;"
                    (change)="selectSecuredUnsecured($event)" name="securedUnsecuredValue" [(ngModel)]="securedUnsecuredValue">
                    <option value="">Select</option>
                    <option *ngFor="let securityList of dropdownList['Security'];"
                      value="{{securityList}}">{{securityList}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Face Value :</label>
                <div class="input-group">
                  <input NcdCommaSeperatedNumber type="text" class="form-control" [(ngModel)]="faceValueModel" name="fieldSearch"/>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Allotment Date (Pay-In Date) :</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input class="form-control" [(ngModel)]="allotmentDateModel" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" name="allotmentDate" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()"
                    required="required">
                  <button class="input-group-addon" (click)="a.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Maturity Date :</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input class="form-control" [(ngModel)]="maturityDateModel" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" name="maturityDate" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()"
                    required="required">
                  <button class="input-group-addon" (click)="b.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Drawn Amount :</label>
                <div class="input-group">
                  <input NcdCommaSeperatedNumber type="text" class="form-control" [(ngModel)]="drawnAmountModel" name="drawnAmountModel"/>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Financial year :</label>
                <div class="input-group">
                  <select class="form-control" id="financialYr" style="padding:6px;" (change)="selectFinancialYr($event)" name="financialYear" [(ngModel)]="selectedFinancialYear">
                      <option value="">Select</option>
                    <option *ngFor="let financialYear of financialYears" value="{{financialYear}}">{{financialYear}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <label class="form-control-label">Listing - NSE/BSE or Both :</label>
                <div class="input-group">
                  <select class="form-control" id="filterListing" style="padding:6px;" (change)="selectListing($event)" name="listing" [(ngModel)]="selectedListing">
                    <option value="">Select</option>
                    <option *ngFor="let Listing of dropdownList['EBP Platform'];" value="{{Listing}}">{{Listing}}
                    </option>
                  </select>
                </div>
              </div>

              <!-- <div class="col-sm-2">
                <label class="form-control-label">Credit Rating Agency :</label>
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="creditRatingAgencyModel" name="creditRatingAgencyModel"/>
                </div>
              </div> -->

              <div class="col-sm-2">
                <label class="form-control-label">Issue type - Public/Private :</label>
                <div class="input-group">
                  <select class="form-control" id="filterIssueType" style="padding:6px;"
                    (change)="selectIssueType($event)" name="issueType" [(ngModel)]="selectedIssueType">
                    <option value="">Select</option>
                    <option *ngFor="let issueType of dropdownList['Mode of Issue'];" value="{{issueType}}">{{issueType}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <!-- <pre> {{termsheetArray  | json  }} </pre>
           

                <span *ngFor="let termsheet of termsheetArray; let j = index;" style="width:125.4px">{{termsheet | json }}</span> -->

            <table datatable [dtOptions]="dtIssueList" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="issueListTable" style="cursor: pointer;">
              <thead>
                <tr>
                  <th style="width:512px">Issue Series</th>
                  <!-- <th style="width:76.2px">Issue size</th> -->
                  <th style="width:96.2px">Coupon Rate</th>
                  <th style="width:193.2px">Deemed Date of Allotment</th>
                  <th style="width:125.4px">Redemption Date </th>
                  <th style="width:66.2px;"><span>Action</span></th>
                  <!-- <th *ngFor="let TSHeader of termsheetHeader" style="width:125.4px">{{TSHeader}}</th>
                  <th *ngFor="let AdditionalFieldsHeader of addFieldarrayHeader" style="width:125.4px">
                    {{AdditionalFieldsHeader}}</th> -->

                  <!-- cashflow OPTION 1 ONLY -->
                  <!-- <th *ngIf="cashflowValueArray.length" style="width:125.4px">Coupon Payment Date (Option 1)</th>
                  <th *ngIf="cashflowValueArray.length" style="width:125.4px">Coupon Payout Date (Option 1)</th>
                  <th *ngIf="cashflowValueArray.length" style="width:125.4px">Principal due for Payment (Option 1)</th>
                  <th *ngIf="cashflowValueArray.length" style="width:125.4px">Principal Payout Date (Option 1)</th> -->

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ncdIssueList of allNcdIssueList; let i = index;" style="line-height: 25px;">

                  <!-- <td tabindex="1">{{securityNameArray[i].Security}} / {{securityNameArray[i].Redeemability}} / {{securityNameArray[i].Convertibility}} [Series "{{ncdIssueList.issuedata.IssueSeries}}" of FY {{ncdIssueList.issuedata.FinancialYear}}]</td> -->
                  <td tabindex="1">Series "{{ncdIssueList.issuedata.IssueSeries}}" of FY [{{ncdIssueList.issuedata.FinancialYear}}]</td>
                  <!-- <td tabindex="1">{{ncdIssueList.issuedata.IssueSize}}</td> -->
                  <td tabindex="1">{{ncdIssueList.issuedata.MultiOption[0].couponRate }}</td>
                  <td tabindex="1">{{ncdIssueList.issuedata.MultiOption[0].payInDate | date: 'dd/MM/yyyy' }}</td>
                  <td tabindex="1">{{ncdIssueList.issuedata.MultiOption[0].redemptionDate | date: 'dd/MM/yyyy' }}</td>
                  <td style='white-space: nowrap !important'>
                    <button type="button" class="btn-sm btn btn-warning"  id="{{ncdIssueList.issuedata._id}}"
                      (click)="loadncdIssueByID(ncdIssueList.issuedata._id);">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;
                    <button type="button" class="btn-sm btn btn-danger" [appHasPermission]="{'Url': '/ncdIssues/deleteIssue', 'method':'delete', 'menu': 'Term Sheet'}"
                      (click)="confirmDelete(ncdIssueList.issuedata._id)">
                      <span class="icmn-bin"></span>
                    </button>
                  </td>
                  <!-- <td *ngFor="let termsheet of termsheetArray[i]; let k = index;" tabindex="1">
                    {{termsheet.DefaultValue}}</td>
                  <td *ngFor="let addFieldvalues of addFieldarrayValues[i]; let k = index;" tabindex="1">
                    {{addFieldvalues}}</td> -->
                  <!-- <td *ngFor="let cashflowValue of cashflowValueArray[i]; let k = index;" tabindex="1">{{cashflowValue[0]}}</td> -->

                  <!-- <td *ngIf="cashflowValueArray.length" tabindex="1">{{cashflowValueArray[i].couponPaymentDate}}</td>
                  <td *ngIf="cashflowValueArray.length" tabindex="1">{{cashflowValueArray[i].couponPayoutDate}}</td>
                  <td *ngIf="cashflowValueArray.length" tabindex="1">
                    {{cashflowValueArray[i].principalDueDateForPayment}}</td>
                  <td *ngIf="cashflowValueArray.length" tabindex="1">{{cashflowValueArray[i].principalPayoutDate}}</td> -->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="confirmDeleteIssue" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Issue?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
          <button type="button" class="btn btn-sm btn-primary" (click)="deleteNcdIssue()" data-dismiss="modal">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Create New Fields -->
  <div class="modal fade" id="createNewFieldsId" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="width: 600px;">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            <i></i>Term Sheet Library Contents</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>